/*!jslint
  this
*/
jQuery(function($) {
  "use strict";

  //Button Circle


   
  $(document).on('click', '.btn-explore a ', function (e) {
    $('.sub-buying').removeClass('active');
    $('.btn-buying a').removeClass('active');
    $('.btn-search a').removeClass('active');
    $('.sub-search').removeClass('active');
    $(this).toggleClass('active');
    $('.sub-explore').toggleClass('active');
  });

  $(document).on('click', '.btn-buying a ', function (e) {
    $('.sub-explore').removeClass('active');
    $('.btn-explore a').removeClass('active');
    $('.btn-search a').removeClass('active');
    $('.sub-search').removeClass('active');
    $(this).toggleClass('active');
    $('.sub-buying').toggleClass('active');
  });

  $(document).on('click', '.btn-search a ', function (e) {
    $('.sub-explore').removeClass('active');
    $('.btn-explore a').removeClass('active');
    $('.sub-buying').removeClass('active');
    $('.btn-buying a').removeClass('active');
    $(this).toggleClass('active');
    $('.sub-search').toggleClass('active');
  });

  $(document).on('click', '.btn-mob-explore a ', function (e) {
    $(this).toggleClass('active');
    $('.sub-mob').toggleClass('active');
  });

  // $(document).on('click', '.sub-mob .menu-item-has-children > a ', function (e) {
  //   if($(this).hasClass('active')){
  //     $(this).removeClass('active');
  //     $(this).parent().find('.sub-menu').removeClass('active');
  //     $('.sub-mob .menu-item-has-children > a').removeClass('hide');

  //   } else {
  //     $('.sub-mob .menu-item-has-children > a').removeClass('active');
  //     $('.sub-mob .sub-menu').removeClass('active');
  //     $(this).addClass('active');
  //     $(this).parent().find('.sub-menu').addClass('active');
  //     $('.sub-mob .menu-item-has-children > a').addClass('hide');
  //   }

  // });

  //Search
  // $(".search-input").on("change paste keyup", function() {
  //   $('.search').attr('action', 'https://www.jayconewcastle.com.au/search?q='+$(this).val());
  // });

  //Weekend Gallery
  if($('.wg-list').length) {
    $('.wg-list').magnificPopup({
      delegate: 'a',
      type: 'image'
    });
  }

  //FAQ
  if($('#accordionFaq').length) {
    $(document).on('click', '.accordion-item .accordion-button', function(e) {
      if($(this).parent().parent().hasClass('active')) {
        $(this).parent().parent().removeClass('active');
      } else {
        $('.accordion-item').removeClass('active');
        $(this).parent().parent().addClass('active');
      }
    });
  }

  $(function() {
    var adjustArticleHeights = (function () {

      var leftColumnHeight = 0,
        rightColumnHeight = 0,
        $articles = $('.accordion-item');

      for (var i = 0; i < $articles.length; i++) {

        if (leftColumnHeight > rightColumnHeight) {
          rightColumnHeight += $articles.eq(i).addClass('right').outerHeight(true);
        } else {
          leftColumnHeight += $articles.eq(i).outerHeight(true);
        }
      }

      return $articles;
    })();
  });

	// var $masonry = $('#accordionFaq');
	// $masonry.masonry({
	// 	itemSelector: '.accordion-item'
	// }).on('shown.bs.collapse hidden.bs.collapse', function() {
	// 	$masonry.masonry();
	// });

  $('#otpform').validate({
    submitHandler: function(form) {
      StarLoading
        wp.ajax.post('jayco_ajax_sms', $(form).serialize()).always(setupLoginForm);
        return false;
    }
  });
  function showMessage(message,messageclass){
    $('#loginmessage').removeClass('d-none alert-success alert-danger');
    $('#loginmessage').html(message);
    $('#loginmessage').addClass(messageclass);
  }
  function setupLoginForm(response){
    StopLoading();
    $('#user_phone1').val($('#user_phone').val());
    if(response.status){
      $('#otpform').fadeOut();
      $('#logiformn').removeClass('d-none').fadeIn();
    }else{
      showMessage(response.message,'alert-danger');
     
    }
  }
	$('#logiformn').validate({
    submitHandler: function(form) {
        StarLoading();
        wp.ajax.post('jayco_ajax_login', $(form).serialize()).always(LoginHandler);
        return false;
    }
  });
  function LoginHandler(response){
    StopLoading();
    if(response.status){
      window.location =  response.redirect;
    }else{
      showMessage(response.message,'alert-danger');
    }
  }
  function StarLoading(){
    $('body').addClass('loading');
  }
  function StopLoading(){
    $('body').removeClass('loading');
  }


  //Dropdown selection
  $(document).on('click', '.om-drop li.parent > label', function (e) {
    e.preventDefault()
      // if($('.om-drop li.parent').hasClass('active')) {
      //   $('.om-drop li.parent').not($(this).parent()).not($(this).parent().parent().parent()).removeClass('active')
        
      // }
      if($('.om-drop li.parent').hasClass('active')) {
        $('.om-drop li.parent').not($(this).parent()).not($(this).parent().parent().parent()).not($(this).parent().parent().parent().parent().parent()).not($(this).parent().parent().parent().parent().parent().parent().parent()).removeClass('active')
      }
      $(this).parent().toggleClass('active');
  });
  $(document).on('click', '.dropdown-menu li.parent > label', function (e) {
    e.preventDefault()
      // if($('.dropdown-menu li.parent').hasClass('active')) {
      //   $('.dropdown-menu li.parent').not($(this).parent()).not($(this).parent().parent().parent()).removeClass('active')
      // }
      if($('.dropdown-menu li.parent').hasClass('active')) {
        $('.dropdown-menu li.parent').not($(this).parent()).not($(this).parent().parent().parent()).not($(this).parent().parent().parent().parent().parent()).not($(this).parent().parent().parent().parent().parent().parent().parent()).removeClass('active')
      }
      $(this).parent().toggleClass('active');
  });

    //Filter
    $(document).on('change', '.filter-list-item input', function (e) {
      
      e.preventDefault();
      if(!$(this).parent().parent().hasClass('parent')) {
        $('#filter-form').submit();      
        $('#manualdrop').dropdown("hide");
      } 
      
      if ($(this).is(':radio')) {
        $(this).parents('.filter-list-item').find('li').removeClass('selected');
        $(this).parents('li').addClass('selected');
      } else {
        if ($(this).parents('li').hasClass('selected')) {
          $(this).parents('li').removeClass('selected');
        } else {
          $(this).parents('li').addClass('selected');
        }
      }
  
    });

    $(document).on('submit', '#filter-form', function (e) {
      e.preventDefault();
      $('body').addClass('loading');
      var params = $(this).serialize(), action = $(this).attr('action'), url = action + '?' + params;

      $("<div>").load(url + " #search-results", function (e) {
        $("#search-results").html($(this).find("#search-results").html());
        $('body').removeClass('loading');
        if (history.pushState) {
          history.pushState(null, null, url);
        };
      });
    });

});
